export default __webpack_public_path__ + "static/media/crypto.b27d8743.svg";